'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const MeetingFAQ = () => {
  const [openId, setOpenId] = useState<number | null>(1);

  const faqs: FAQItem[] = [
  {
    id: 1,
    question: 'Musím se na schůzku nějak připravovat?',
    answer: 'Ideální je mít přehled o svých příjmech, výdajích a závazcích. Pokud jste vyplnili online diagnózu, máte již dobrou výchozí pozici. Pokud ne, nevadí – společně projdeme vše potřebné během schůzky. Seznam doporučených dokumentů najdete výše na této stránce.'
  },
  {
    id: 2,
    question: 'Co když nemám všechny dokumenty?',
    answer: 'Není problém. I částečný přehled nám pomůže. Během schůzky identifikujeme, jaké informace ještě potřebujeme, a můžete je doplnit později. Důležitější než dokonalá příprava je vaše otevřenost a ochota mluvit o své situaci.'
  },
  {
    id: 3,
    question: 'Je první schůzka zpoplatněná?',
    answer: 'První konzultace je zcela zdarma a nezávazná. Chceme, abyste měli možnost poznat náš přístup a rozhodnout se, zda je naše spolupráce pro vás ta pravá. Žádné skryté poplatky, žádná překvapení.'
  },
  {
    id: 4,
    question: 'Můžu přijít s partnerem/partnerkou?',
    answer: 'Určitě ano, dokonce to doporučujeme! Finanční rozhodnutí často ovlivňují celou rodinu, takže je ideální, když jsou oba partneři přítomni a mohou se zapojit do diskuse. Stačí nám to předem vědět kvůli rezervaci vhodné místnosti.'
  },
  {
    id: 5,
    question: 'Co když si během schůzky uvědomím, že to není pro mě?',
    answer: 'Žádný problém. Můžete schůzku kdykoliv ukončit nebo se rozhodnout nepokračovat. Naším cílem není vás přesvědčit za každou cenu, ale nabídnout vám hodnotu. Pokud cítíte, že naše služby nejsou pro vás, rozejdeme se v dobrém.'
  },
  {
    id: 6,
    question: 'Jak dlouho trvá, než uvidím výsledky?',
    answer: 'První schůzka vám poskytne okamžitý přehled o vaší situaci a možných krocích. Pokud se rozhodnete pokračovat, začneme tvořit váš finanční plán během 2-3 týdnů. Konkrétní výsledky závisí na vašich cílech – některé kroky můžete implementovat hned, jiné vyžadují delší časový horizont.'
  },
  {
    id: 7,
    question: 'Můžu schůzku přesunout nebo zrušit?',
    answer: 'Samozřejmě. Stačí nás kontaktovat alespoň 24 hodin předem emailem nebo telefonicky. Domluvíme nový termín, který vám bude vyhovovat. Chápeme, že život přináší nečekané situace.'
  },
  {
    id: 8,
    question: 'Jak probíhá online schůzka technicky?',
    answer: 'Používáme Google Meet, Zoom nebo Microsoft Teams podle vaší preference. Den před schůzkou vám pošleme odkaz na videohovor. Potřebujete pouze počítač nebo tablet s webkamerou, mikrofonem a stabilní internetové připojení. Pokud máte technické problémy, pomůžeme vám je vyřešit.'
  }];


  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
              Časté otázky k první schůzce
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Odpovědi na nejčastější dotazy, které nám klienti kladou před první konzultací
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq) =>
            <div
              key={faq.id}
              className="bg-card border border-border rounded-lg overflow-hidden shadow-card hover:shadow-elevated transition-smooth">

                <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-surface transition-smooth">

                  <span className="text-lg font-semibold text-text-primary pr-4">
                    {faq.question}
                  </span>
                  <Icon
                  name="ChevronDownIcon"
                  size={24}
                  className={`text-primary flex-shrink-0 transition-transform duration-300 ${
                  openId === faq.id ? 'rotate-180' : ''}`
                  } />

                </button>
                
                <div
                className={`overflow-hidden transition-all duration-300 ${
                openId === faq.id ? 'max-h-96' : 'max-h-0'}`
                }>

                  <div className="px-6 pb-5 pt-2">
                    <p className="text-text-secondary leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          
























        </div>
      </div>
    </section>);

};

export default MeetingFAQ;